(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-brand-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVabicaStory(scope) {
      var roots = [];
      if (scope && scope.matches && scope.matches('[data-vbs]')) {
        roots.push(scope);
      }
      if (scope && scope.querySelectorAll) {
        var found = scope.querySelectorAll('[data-vbs]');
        for (var i = 0; i < found.length; i += 1) {
          roots.push(found[i]);
        }
      }

      roots.forEach(function (root) {
        if (root.dataset.vbsInitialized === 'true') return;
        root.dataset.vbsInitialized = 'true';
        root.classList.add('vbs--motion');

        var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion || !('IntersectionObserver' in window)) {
          root.classList.add('is-visible');
          return;
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            root.classList.add('is-visible');
            observer.unobserve(root);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

        observer.observe(root);
      });
    }

    initVabicaStory(document);
    document.addEventListener('shopify:section:load', function (event) {
      initVabicaStory(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-canister-controls"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-canister-controls')) {
  customElements.define('vabica-canister-controls', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.tabs = [...this.querySelectorAll('[data-control-tab]')];
      this.panels = [...this.querySelectorAll('[data-control-panel]')];
      this.tablist = this.querySelector('[data-controls-tabs]');
      if (this.tabs.length !== 3 || this.panels.length !== 3 || !this.tablist) return;
      this.bound = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.entrances = new Map();
      this.seen = new WeakSet();
      this.index = -1;
      this.handlers = [];
      this.tablist.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        const click = event => { event.preventDefault(); this.cancelEntrances(); this.select(index); };
        const keydown = event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key === ' ' || event.key === 'Enter') next = index;
          else return;
          event.preventDefault();
          this.cancelEntrances();
          this.select(next);
          this.tabs[next].focus({ preventScroll: true });
        };
        tab.addEventListener('click', click);
        tab.addEventListener('keydown', keydown);
        this.handlers.push({ tab, click, keydown });
      });
      this.select(0, false);
      this.classList.add('is-ready');
      this.onMotion = () => {
        if (this.motion.matches) { this.cancelEntrances(); this.transition?.cancel(); this.observer?.disconnect(); }
      };
      this.onVisibility = () => { if (document.hidden) { this.cancelEntrances(); this.transition?.cancel(); } };
      this.onFocus = () => this.cancelEntrances();
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.addEventListener('focusin', this.onFocus);
      if (!this.entered && !this.motion.matches && 'IntersectionObserver' in window && Element.prototype.animate) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting || this.seen.has(entry.target)) return;
            this.seen.add(entry.target);
            this.observer.unobserve(entry.target);
            if (this.motion.matches || document.hidden || entry.target.contains(document.activeElement)) return;
            try {
              const animation = entry.target.animate([{ opacity: .65, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
              this.entrances.set(entry.target, animation);
              const clear = () => { if (this.entrances.get(entry.target) === animation) this.entrances.delete(entry.target); };
              animation.onfinish = animation.oncancel = clear;
            } catch (_) {}
          });
        }, { threshold: 0, rootMargin: '0px 0px -16px 0px' });
        this.querySelectorAll('[data-controls-entry]').forEach(target => this.observer.observe(target));
      }
      this.entered = true;
    }
    select(index, animate = true) {
      if (index === this.index) return;
      this.transition?.cancel();
      this.transition = null;
      this.index = index;
      this.tabs.forEach((tab, number) => {
        const selected = number === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[number].setAttribute('aria-hidden', String(!selected));
        this.panels[number].inert = !selected;
        this.panels[number].tabIndex = selected ? 0 : -1;
      });
      if (animate && !this.motion.matches && Element.prototype.animate) {
        try { this.transition = this.panels[index].animate([{ opacity: .65 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' }); } catch (_) {}
      }
    }
    cancelEntrances() {
      this.entrances.forEach(animation => animation.cancel());
      this.entrances.clear();
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.observer?.disconnect();
      this.cancelEntrances();
      this.transition?.cancel();
      this.handlers.forEach(({ tab, click, keydown }) => {
        tab.removeEventListener('click', click);
        tab.removeEventListener('keydown', keydown);
        tab.removeAttribute('role');
        tab.removeAttribute('aria-selected');
        tab.removeAttribute('aria-controls');
        tab.removeAttribute('tabindex');
      });
      this.panels.forEach(panel => {
        panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); panel.removeAttribute('aria-hidden'); panel.removeAttribute('tabindex'); panel.inert = false;
      });
      this.tablist.removeAttribute('role');
      this.classList.remove('is-ready');
      this.motion.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.removeEventListener('focusin', this.onFocus);
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-canister-ritual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-canister-ritual')) {
  customElements.define('vabica-canister-ritual', class extends HTMLElement {
    connectedCallback() {
      if (this.bound || this.played || !Element.prototype.animate || !('IntersectionObserver' in window)) return;
      this.bound = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.active = new Set();
      this.seen = new WeakSet();
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || this.seen.has(entry.target)) return;
          this.seen.add(entry.target);
          this.observer.unobserve(entry.target);
          if (this.motion.matches || document.hidden) return;
          try {
            const animation = entry.target.animate([
              { opacity: .65, transform: 'translateY(12px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
            this.active.add(animation);
            animation.onfinish = animation.oncancel = () => this.active.delete(animation);
          } catch (_) {}
        });
      }, { threshold: 0, rootMargin: '0px 0px -16px 0px' });
      this.onMotion = () => {
        if (!this.motion.matches) return;
        this.observer.disconnect();
        this.active.forEach(animation => animation.cancel());
        this.active.clear();
      };
      this.onVisibility = () => {
        if (document.hidden) {
          this.active.forEach(animation => animation.cancel());
          this.active.clear();
        }
      };
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      if (!this.motion.matches) this.querySelectorAll('[data-canister-motion]').forEach(target => this.observer.observe(target));
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.observer.disconnect();
      this.active.forEach(animation => animation.cancel());
      this.active.clear();
      this.motion.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.bound = false;
      this.played = true;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-canister-sizes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-canister-sizes')) {
  customElements.define('vabica-canister-sizes', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.buttons = [...this.querySelectorAll('[data-canister-size-button]')];
      this.live = this.querySelector('[data-size-live]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Map();
      this.seen = new WeakSet();
      this.onClick = event => {
        const button = event.target.closest('[data-canister-size-button]');
        if (!button || !this.contains(button) || !this.ready) return;
        event.preventDefault();
        this.choose(button);
      };
      this.onKey = event => {
        const button = event.target.closest('[data-canister-size-button]');
        if (event.key !== ' ' || !button || !this.ready) return;
        event.preventDefault(); this.choose(button);
      };
      this.onSourceChange = event => {
        const main = this.mainProduct();
        if (main?.contains(event.target) && event.target.closest('variant-selects')) this.setBusy(true);
      };
      this.bindBackend = () => {
        if (!this.isConnected || this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        const main = this.mainProduct();
        if (!main || !customElements.get('variant-selects') || !customElements.get('product-info')) return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, message => {
          if (String(message.data?.sectionId) !== String(this.mainProduct()?.dataset.section)) return;
          this.setBusy(false); this.sync(true);
        });
        this.ready = true;
        this.buttons.forEach(button => { button.setAttribute('role', 'button'); button.removeAttribute('aria-current'); });
        this.sync(false);
      };
      this.onMotion = () => { if (this.motion.matches) this.cancelAnimations(); };
      this.onFocus = () => this.cancelAnimations();
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('focusin', this.onFocus);
      document.addEventListener('change', this.onSourceChange);
      document.addEventListener('product-info:loaded', this.bindBackend);
      this.motion.addEventListener('change', this.onMotion);
      this.bindBackend();
      Promise.all([customElements.whenDefined('product-info'), customElements.whenDefined('variant-selects')]).then(() => this.bindBackend());
      if (!this.entered && !this.motion.matches && 'IntersectionObserver' in window && Element.prototype.animate) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting || this.seen.has(entry.target)) return;
          this.seen.add(entry.target); this.observer.unobserve(entry.target);
          if (this.motion.matches || document.hidden || entry.target.contains(document.activeElement)) return;
          try {
            const animation = entry.target.animate([{ opacity: .65, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
            this.animations.set(entry.target, animation);
            const clear = () => this.animations.delete(entry.target);
            animation.onfinish = animation.oncancel = clear;
          } catch (_) {}
        }), { threshold: 0, rootMargin: '0px 0px -16px 0px' });
        this.querySelectorAll('[data-sizes-entry]').forEach(target => this.observer.observe(target));
      }
      this.entered = true;
    }
    mainProduct() {
      return [...document.querySelectorAll('product-info[id^="MainProduct-"]')].find(main => main.querySelector('variant-selects')?.dataset.productId === this.dataset.productId);
    }
    picker() { return this.mainProduct()?.querySelector('variant-selects'); }
    selectedValue() {
      try {
        const variant = JSON.parse(this.picker()?.querySelector('[data-selected-variant]')?.textContent || 'null');
        return variant?.options?.[Number(this.dataset.optionIndex)] || variant?.option1 || null;
      } catch (_) { return null; }
    }
    sync(announce = false) {
      const value = this.selectedValue();
      if (!value) return;
      this.buttons.forEach(button => {
        const selected = button.dataset.optionValue === value;
        button.closest('[data-size-card]').dataset.selected = String(selected);
        if (this.ready) button.setAttribute('aria-pressed', String(selected));
        if (selected && announce && this.live) this.live.textContent = this.dataset.selectedText + ' ' + button.dataset.sizeLabel;
      });
    }
    setBusy(busy) {
      this.busy = busy;
      clearTimeout(this.timeout);
      this.setAttribute('aria-busy', String(busy));
      this.buttons.forEach(button => button.setAttribute('aria-disabled', String(busy)));
      if (busy) {
        if (this.live) this.live.textContent = this.dataset.updatingText;
        this.timeout = setTimeout(() => {
          this.setBusy(false); this.sync(false);
          if (this.live) this.live.textContent = this.dataset.errorText;
        }, 15000);
      }
    }
    choose(button) {
      if (this.busy || !this.ready) return;
      this.cancelAnimations();
      const picker = this.picker();
      const value = button.dataset.optionValue;
      if (this.selectedValue() === value) { this.sync(true); return; }
      const group = picker?.querySelectorAll('fieldset, .product-form__input--dropdown')[Number(this.dataset.optionIndex)];
      const radio = group && [...group.querySelectorAll('input[type="radio"]')].find(input => input.value === value);
      const select = group?.querySelector('select');
      let control;
      if (radio && !radio.disabled) { radio.checked = true; control = radio; }
      else if (select && [...select.options].some(option => option.value === value && !option.disabled)) { select.value = value; control = select; }
      if (!control) { if (this.live) this.live.textContent = this.dataset.errorText; return; }
      this.setBusy(true);
      control.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { vabicaCapacityFocusId: button.id } }));
    }
    cancelAnimations() {
      this.animations.forEach(animation => animation.cancel()); this.animations.clear();
    }
    disconnectedCallback() {
      if (!this.bound) return;
      clearTimeout(this.timeout); this.unsubscribe?.(); this.unsubscribe = null;
      this.observer?.disconnect(); this.cancelAnimations();
      this.removeEventListener('click', this.onClick); this.removeEventListener('keydown', this.onKey); this.removeEventListener('focusin', this.onFocus);
      document.removeEventListener('change', this.onSourceChange); document.removeEventListener('product-info:loaded', this.bindBackend);
      this.motion.removeEventListener('change', this.onMotion);
      this.buttons.forEach(button => { button.removeAttribute('role'); button.removeAttribute('aria-pressed'); button.removeAttribute('aria-disabled'); });
      this.ready = false; this.busy = false; this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-canister-support"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-canister-support')) {
  customElements.define('vabica-canister-support', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Map();
      this.items = [...this.querySelectorAll('details')];
      this.clickHandler = event => {
        const summary = event.target.closest('summary');
        if (summary && this.contains(summary)) {
          event.preventDefault();
          const item = summary.parentElement;
          const opening = item.dataset.expanding !== 'true' && (!item.open || item.dataset.expanding === 'false');
          this.items.forEach(other => { if (other !== item && other.open) this.toggleItem(other, false); });
          this.toggleItem(item, opening);
          return;
        }
        const link = event.target.closest('[data-support-anchor]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        const focusTarget = target.querySelector('input:checked,select,summary,button,a') || target;
        const temporaryFocus = !focusTarget.matches('input,select,summary,button,a,[tabindex]');
        if (temporaryFocus) focusTarget.tabIndex = -1;
        focusTarget.focus({ preventScroll: true });
        if (temporaryFocus) focusTarget.addEventListener('blur', () => focusTarget.removeAttribute('tabindex'), { once: true });
        const header = document.querySelector('.shopify-section-header,sticky-header');
        const offset = (header?.getBoundingClientRect().height || 96) + 24;
        window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset), behavior: this.motion.matches ? 'instant' : 'smooth' });
      };
      this.addEventListener('click', this.clickHandler);
      this.items.forEach(item => item.removeAttribute('name'));
      this.main = document.getElementById(this.dataset.mainId);
      this.sync = () => {
        if (!this.main) return;
        const picker = this.main.querySelector('variant-selects');
        const data = picker?.querySelector('[data-selected-variant]')?.textContent;
        let variant;
        try { variant = JSON.parse(data || 'null'); } catch (_) {}
        const capacity = this.querySelector('[data-support-capacity]');
        const value = variant?.options?.[0] || picker?.querySelector('input:checked')?.value || picker?.querySelector('select')?.value;
        if (value && capacity) capacity.textContent = String(value).replace(/\s*L$/i, ' L');
        const change = this.querySelector('[data-support-anchor="picker"]');
        if (change && picker?.id) change.setAttribute('href', '#' + picker.id);
        const source = this.main.querySelector('.vabica-product__purchase .vabica-product__amazon');
        const button = this.querySelector('[data-support-amazon]');
        const note = this.querySelector('[data-support-amazon-note]');
        if (source && button) {
          ['href', 'target', 'rel'].forEach(attribute => {
            const current = source.getAttribute(attribute);
            if (current === null) button.removeAttribute(attribute);
            else button.setAttribute(attribute, current);
          });
          if (note) note.hidden = source.target !== '_blank';
        }
      };
      this.sync();
      if (this.main) {
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.main, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'target', 'rel'] });
      }
      this.motionHandler = () => { if (this.motion.matches) this.items.forEach(item => { if (this.animations.has(item)) this.finishItem(item, item.dataset.expanding === 'true'); }); };
      this.motion.addEventListener('change', this.motionHandler);
      this.querySelectorAll('[data-support-anchor="compare"]').forEach(link => { if (!document.getElementById(link.hash.slice(1))) link.hidden = true; });
    }
    toggleItem(item, opening) {
      const start = item.getBoundingClientRect().height;
      this.animations.get(item)?.cancel();
      this.animations.delete(item);
      item.dataset.expanding = String(opening);
      if (this.motion.matches || !item.animate) { this.finishItem(item, opening); return; }
      item.open = true;
      const summary = item.querySelector('summary');
      const answer = item.querySelector('.vb-canister-support__answer');
      const end = summary.getBoundingClientRect().height + (opening ? answer.getBoundingClientRect().height : 0) + 1;
      item.style.overflow = 'hidden';
      const animation = item.animate([{ height: start + 'px' }, { height: end + 'px' }], { duration: 230, easing: 'ease-in-out' });
      this.animations.set(item, animation);
      animation.onfinish = () => this.finishItem(item, opening);
    }
    finishItem(item, opening) {
      this.animations.get(item)?.cancel();
      this.animations.delete(item);
      item.open = opening;
      item.style.removeProperty('overflow');
      delete item.dataset.expanding;
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.items.forEach(item => this.finishItem(item, item.open));
      this.observer?.disconnect();
      this.removeEventListener('click', this.clickHandler);
      this.motion.removeEventListener('change', this.motionHandler);
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-collection-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-collection')) {
  customElements.define('vabica-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const cards = this.querySelectorAll('.vb-collection__card');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motionQuery.matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('vb-collection__pending');
          entry.target.classList.add('vb-collection__revealed');
          this.observer.unobserve(entry.target);
        });
      }, { threshold: 0.08 });
      cards.forEach((card) => {
        if (card.getBoundingClientRect().top >= window.innerHeight) {
          card.classList.add('vb-collection__pending');
          this.observer.observe(card);
        }
      });
      this.onMotionChange = () => {
        if (!this.motionQuery.matches) return;
        this.observer.disconnect();
        cards.forEach((card) => card.classList.remove('vb-collection__pending', 'vb-collection__revealed'));
      };
      this.motionQuery.addEventListener('change', this.onMotionChange);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onMotionChange) this.motionQuery.removeEventListener('change', this.onMotionChange);
      this.observer = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-faq')) {
  customElements.define('vabica-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.bound || !Element.prototype.animate) return;
      this.bound = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.states = [];
      this.entrances = new Map();
      this.querySelectorAll('.vb-faq__item').forEach(details => {
        const summary = details.querySelector('summary');
        const answer = details.querySelector('.vb-faq__answer');
        const state = { details, summary, answer, open: details.open, animation: null, fade: null };
        const settle = () => {
          const animation = state.animation;
          state.animation = null;
          if (animation) animation.cancel();
          state.fade?.cancel();
          state.fade = null;
          details.open = state.open;
          details.style.height = '';
          details.style.overflow = '';
          summary.setAttribute('aria-expanded', String(state.open));
          answer.inert = !state.open;
        };
        state.settle = settle;
        state.click = event => {
          event.preventDefault();
          this.entrances.get(details)?.cancel();
          const start = details.getBoundingClientRect().height;
          state.open = !state.open;
          const previous = state.animation;
          state.animation = null;
          previous?.cancel();
          state.fade?.cancel();
          summary.setAttribute('aria-expanded', String(state.open));
          answer.inert = !state.open;
          if (this.motion.matches) { settle(); return; }
          details.open = true;
          const end = summary.offsetHeight + (state.open ? answer.offsetHeight : 0) + 1;
          details.style.height = start + 'px';
          details.style.overflow = 'hidden';
          try {
            const animation = details.animate([{ height: start + 'px' }, { height: end + 'px' }], {
              duration: this.mobile.matches ? 220 : 280,
              easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'
            });
            state.animation = animation;
            animation.onfinish = () => { if (state.animation === animation) settle(); };
            if (state.open) state.fade = answer.animate([{ opacity: .65 }, { opacity: 1 }], { duration: this.mobile.matches ? 160 : 220, easing: 'ease-out' });
          } catch (_) { settle(); }
        };
        state.toggle = () => {
          if (state.animation) return;
          state.open = details.open;
          summary.setAttribute('aria-expanded', String(state.open));
          answer.inert = !state.open;
        };
        summary.setAttribute('aria-expanded', String(state.open));
        answer.inert = !state.open;
        summary.addEventListener('click', state.click);
        details.addEventListener('toggle', state.toggle);
        this.states.push(state);
      });
      if (!this.entered && !this.motion.matches) {
        this.entered = true;
        const targets = [this.querySelector('.vb-faq__header'), ...this.querySelectorAll('.vb-faq__item')];
        targets.forEach((target, index) => {
          if (!target) return;
          try {
            const animation = target.animate([
              { opacity: .7, transform: 'translateY(' + (this.mobile.matches ? 4 : 8) + 'px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: this.mobile.matches ? 320 : 400, delay: index ? (index - 1) * 50 : 0, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
            this.entrances.set(target, animation);
            const clear = () => this.entrances.delete(target);
            animation.onfinish = clear;
            animation.oncancel = clear;
          } catch (_) {}
        });
      }
      this.onChange = () => {
        this.states.forEach(state => state.settle());
        this.entrances.forEach(animation => animation.cancel());
        this.entrances.clear();
      };
      this.onFocus = event => {
        this.entrances.forEach((animation, target) => { if (target.contains(event.target)) animation.cancel(); });
      };
      this.motion.addEventListener('change', this.onChange);
      this.mobile.addEventListener('change', this.onChange);
      window.addEventListener('resize', this.onChange, { passive: true });
      this.addEventListener('focusin', this.onFocus);
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.onChange();
      this.states.forEach(state => {
        state.summary.removeEventListener('click', state.click);
        state.details.removeEventListener('toggle', state.toggle);
        state.summary.removeAttribute('aria-expanded');
        state.answer.inert = false;
      });
      this.motion.removeEventListener('change', this.onChange);
      this.mobile.removeEventListener('change', this.onChange);
      window.removeEventListener('resize', this.onChange);
      this.removeEventListener('focusin', this.onFocus);
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-lab-showcase"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vabica-lab')){
customElements.define('vabica-lab',class extends HTMLElement{
connectedCallback(){
if(this.bound)return;
this.bound=true;
this.motion=matchMedia('(prefers-reduced-motion: reduce)');
this.desktop=matchMedia('(min-width: 750px)');
this.update=()=>{
this.frame=null;
if(!this.active||this.motion.matches||!this.desktop.matches||document.hidden){this.style.removeProperty('--vbl-parallax');return;}
const r=this.getBoundingClientRect();
this.style.setProperty('--vbl-parallax',Math.max(-12,Math.min(12,(innerHeight/2-r.top-r.height/2)*.025))+'px');
};
this.onScroll=()=>{if(this.active&&!this.motion.matches&&this.desktop.matches&&!document.hidden&&!this.frame)this.frame=requestAnimationFrame(this.update);};
if('IntersectionObserver' in window){
this.observer=new IntersectionObserver(entries=>{
this.active=entries[0].isIntersecting;
this.update();
},{threshold:0});
this.observer.observe(this);
}
this.onChange=()=>{this.update();};
this.motion.addEventListener('change',this.onChange);
this.desktop.addEventListener('change',this.onChange);
window.addEventListener('scroll',this.onScroll,{passive:true});
window.addEventListener('resize',this.onScroll,{passive:true});
document.addEventListener('visibilitychange',this.onChange);
}
disconnectedCallback(){
this.observer?.disconnect();
this.motion?.removeEventListener('change',this.onChange);
this.desktop?.removeEventListener('change',this.onChange);
window.removeEventListener('scroll',this.onScroll);
window.removeEventListener('resize',this.onScroll);
document.removeEventListener('visibilitychange',this.onChange);
if(this.frame)cancelAnimationFrame(this.frame);
this.bound=false;
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-scale-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-scale-details')) {
  customElements.define('vabica-scale-details', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.seen = this.seen || new WeakSet();
      this.animations = new Set();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.stop = () => {
        this.observer?.disconnect();
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
      };
      this.onMotion = () => { if (this.motion.matches) this.stop(); };
      this.motion.addEventListener('change', this.onMotion);
      if (this.motion.matches || !Element.prototype.animate || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target);
          if (this.seen.has(entry.target)) return;
          this.seen.add(entry.target);
          if (this.motion.matches || entry.target.contains(document.activeElement)) return;
          const animation = entry.target.animate([{ opacity: 0.75 }, { opacity: 1 }], { duration: 350, easing: 'ease-out' });
          this.animations.add(animation);
          animation.onfinish = () => this.animations.delete(animation);
        });
      }, { threshold: 0.08 });
      this.querySelectorAll('[data-scale-details-entry]').forEach(element => { if (!this.seen.has(element)) this.observer.observe(element); });
    }
    disconnectedCallback() {
      this.stop?.();
      this.motion?.removeEventListener('change', this.onMotion);
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-scale-dosing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-scale-dosing')) {
  customElements.define('vabica-scale-dosing', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.seen = this.seen || new WeakSet();
      this.active = new Set();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.cancelAnimations = () => {
        this.active.forEach(animation => animation.cancel());
        this.active.clear();
      };
      this.onMotion = () => {
        if (!this.motion.matches) return;
        this.observer?.disconnect();
        this.cancelAnimations();
      };
      this.onVisibility = () => { if (document.hidden) this.cancelAnimations(); };
      this.link = this.querySelector('[data-scale-details-link]');
      this.onClick = event => {
        if (!this.link || !this.link.contains(event.target) || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(this.link.hash.slice(1));
        if (!target || target === this) return;
        event.preventDefault();
        const heading = target.querySelector('h2,h3') || target;
        const temporaryFocus = !heading.hasAttribute('tabindex');
        if (temporaryFocus) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
        if (temporaryFocus) heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), { once: true });
        const header = document.querySelector('.shopify-section-header,sticky-header');
        const offset = (header?.getBoundingClientRect().height || 80) + 24;
        window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset), behavior: this.motion.matches ? 'instant' : 'smooth' });
      };
      if (this.link && !document.getElementById(this.link.hash.slice(1))) this.link.hidden = true;
      this.addEventListener('click', this.onClick);
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      if (!Element.prototype.animate || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || this.seen.has(entry.target)) return;
          this.seen.add(entry.target);
          this.observer.unobserve(entry.target);
          if (this.motion.matches || document.hidden) return;
          const copy = entry.target.dataset.scaleMotion === 'copy';
          const frames = copy
            ? [{ opacity: .65, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }]
            : [{ opacity: .75 }, { opacity: 1 }];
          try {
            const animation = entry.target.animate(frames, { duration: copy ? 450 : 350, easing: 'cubic-bezier(.22,1,.36,1)' });
            this.active.add(animation);
            animation.onfinish = animation.oncancel = () => this.active.delete(animation);
          } catch (_) {}
        });
      }, { threshold: 0, rootMargin: '0px 0px -16px 0px' });
      if (!this.motion.matches) this.querySelectorAll('[data-scale-motion]').forEach(target => this.observer.observe(target));
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.observer?.disconnect();
      this.cancelAnimations();
      this.removeEventListener('click', this.onClick);
      this.motion.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-scale-readings"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-scale-readings')) {
  customElements.define('vabica-scale-readings', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.seen = this.seen || new WeakSet();
      this.active = new Set();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.cancelAnimations = () => {
        this.active.forEach(animation => animation.cancel());
        this.active.clear();
      };
      this.onMotion = () => {
        if (!this.motion.matches) return;
        this.observer?.disconnect();
        this.cancelAnimations();
      };
      this.onVisibility = () => { if (document.hidden) this.cancelAnimations(); };
      this.onFocus = () => this.cancelAnimations();
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.addEventListener('focusin', this.onFocus);
      if (!Element.prototype.animate || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || this.seen.has(entry.target)) return;
          this.seen.add(entry.target);
          this.observer.unobserve(entry.target);
          if (this.motion.matches || document.hidden || entry.target.contains(document.activeElement)) return;
          const heading = entry.target.dataset.readingsMotion === 'heading';
          const frames = heading
            ? [{ opacity: .65, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }]
            : [{ opacity: .75 }, { opacity: 1 }];
          try {
            const animation = entry.target.animate(frames, { duration: heading ? 450 : 300, easing: 'cubic-bezier(.22,1,.36,1)' });
            this.active.add(animation);
            animation.onfinish = animation.oncancel = () => this.active.delete(animation);
          } catch (_) {}
        });
      }, { threshold: 0, rootMargin: '0px 0px -16px 0px' });
      if (!this.motion.matches) this.querySelectorAll('[data-readings-motion]').forEach(target => this.observer.observe(target));
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.observer?.disconnect();
      this.cancelAnimations();
      this.motion.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.removeEventListener('focusin', this.onFocus);
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-scale-support"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-scale-support')) {
  customElements.define('vabica-scale-support', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.items = Array.from(this.querySelectorAll('details'));
      this.animations = new Map();
      this.entryAnimations = new Set();
      this.seen = this.seen || new WeakSet();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.nativeNames = new Map(this.items.map(item => [item, item.getAttribute('name')]));
      this.onClick = event => {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        const item = summary.parentElement;
        const opening = item.dataset.opening === undefined ? !item.open : item.dataset.opening !== 'true';
        if (opening) this.items.forEach(other => { if (other !== item && (other.open || other.dataset.opening === 'true')) this.toggleItem(other, false); });
        this.toggleItem(item, opening);
      };
      this.finishAll = () => {
        Array.from(this.animations.entries()).forEach(([item, record]) => this.finishItem(item, record.opening));
        this.entryAnimations.forEach(animation => animation.cancel());
        this.entryAnimations.clear();
      };
      this.onMotion = () => { if (this.motion.matches) { this.observer?.disconnect(); this.finishAll(); } };
      this.onVisibility = () => { if (document.hidden) this.finishAll(); };
      this.onResize = () => this.finishAll();
      this.onBlockSelect = event => {
        const item = event.target.closest('details');
        if (!item || !this.contains(item)) return;
        this.items.forEach(other => { if (other !== item) this.finishItem(other, false); });
        this.finishItem(item, true);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('resize', this.onResize);
      this.items.forEach(item => {
        item.removeAttribute('name');
        item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
      });
      this.main = Array.from(document.querySelectorAll('product-info[id^="MainProduct-"]')).find(main => main.dataset.productId === this.dataset.productId);
      if (this.main && 'MutationObserver' in window) {
        this.purchaseObserver = new MutationObserver(() => this.syncAmazon());
        this.purchaseObserver.observe(this.main, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
      }
      this.syncAmazon();
      if (!Element.prototype.animate || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || this.seen.has(entry.target)) return;
          this.seen.add(entry.target);
          this.observer.unobserve(entry.target);
          if (this.motion.matches || document.hidden || entry.target.contains(document.activeElement)) return;
          try {
            const animation = entry.target.animate([{ opacity: .7 }, { opacity: 1 }], { duration: 350, easing: 'ease-out' });
            this.entryAnimations.add(animation);
            animation.onfinish = animation.oncancel = () => this.entryAnimations.delete(animation);
          } catch (_) {}
        });
      }, { threshold: 0, rootMargin: '0px 0px -16px 0px' });
      if (!this.motion.matches) this.querySelectorAll('[data-scale-support-entry]').forEach(target => this.observer.observe(target));
    }
    syncAmazon() {
      const source = this.main?.querySelector('.vabica-product__purchase .vabica-product__amazon');
      const button = this.querySelector('[data-support-amazon]');
      const href = source?.getAttribute('href');
      if (button && href) button.setAttribute('href', href);
    }
    toggleItem(item, opening) {
      const start = item.getBoundingClientRect().height;
      const old = this.animations.get(item);
      if (old) { old.animation.onfinish = null; old.animation.cancel(); this.animations.delete(item); }
      item.dataset.opening = String(opening);
      item.querySelector('summary').setAttribute('aria-expanded', String(opening));
      if (this.motion.matches || !item.animate) { this.finishItem(item, opening); return; }
      item.open = true;
      const summary = item.querySelector('summary');
      const answer = item.querySelector('.vb-scale-support__answer');
      const end = summary.getBoundingClientRect().height + (opening ? answer.getBoundingClientRect().height : 0) + 1;
      item.style.overflow = 'hidden';
      try {
        const animation = item.animate([{ height: start + 'px' }, { height: end + 'px' }], { duration: 230, easing: 'ease-in-out' });
        const record = { animation, opening };
        this.animations.set(item, record);
        animation.onfinish = () => { if (this.animations.get(item) === record) this.finishItem(item, opening); };
      } catch (_) { this.finishItem(item, opening); }
    }
    finishItem(item, opening) {
      const record = this.animations.get(item);
      if (record) {
        record.animation.onfinish = null;
        this.animations.delete(item);
        record.animation.cancel();
      }
      item.open = opening;
      item.style.overflow = '';
      delete item.dataset.opening;
      item.querySelector('summary').setAttribute('aria-expanded', String(opening));
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.observer?.disconnect();
      this.purchaseObserver?.disconnect();
      this.finishAll();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.motion.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('resize', this.onResize);
      this.items.forEach(item => {
        const name = this.nativeNames.get(item);
        if (name !== null) item.setAttribute('name', name);
        item.querySelector('summary').removeAttribute('aria-expanded');
      });
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-studio-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-hero')) {
  customElements.define('vabica-hero', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.vb-hero__playback');
      if (!this.video || !this.button || this.bound) return;
      this.bound = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.wantsPlay = !this.motion.matches;
      this.inView = true;
      this.video.muted = true;
      this.update = () => {
        const paused = this.video.paused;
        this.button.classList.toggle('is-paused', paused);
        this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
      };
      this.applyPlayback = () => {
        if (this.wantsPlay && this.inView && !document.hidden) {
          const attempt = this.video.play();
          if (attempt) attempt.catch(() => this.update());
        } else this.video.pause();
        this.update();
      };
      this.togglePlayback = () => {
        this.wantsPlay = this.video.paused;
        this.applyPlayback();
      };
      this.changeMotion = () => {
        this.wantsPlay = !this.motion.matches;
        this.applyPlayback();
      };
      this.video.addEventListener('play', this.update);
      this.video.addEventListener('pause', this.update);
      this.button.addEventListener('click', this.togglePlayback);
      this.motion.addEventListener('change', this.changeMotion);
      document.addEventListener('visibilitychange', this.applyPlayback);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.applyPlayback();
        }, { threshold: 0 });
        this.observer.observe(this);
      }
      this.button.hidden = false;
      this.applyPlayback();
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.video.pause();
      this.video.removeEventListener('play', this.update);
      this.video.removeEventListener('pause', this.update);
      this.button.removeEventListener('click', this.togglePlayback);
      this.motion.removeEventListener('change', this.changeMotion);
      document.removeEventListener('visibilitychange', this.applyPlayback);
      this.observer?.disconnect();
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-tamping-action"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-tamping-action')) {
  customElements.define('vabica-tamping-action', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.seen = this.seen || new WeakSet();
      this.active = new Set();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.cancelAnimations = () => {
        this.active.forEach(animation => animation.cancel());
        this.active.clear();
      };
      this.onMotion = () => {
        if (!this.motion.matches) return;
        this.observer?.disconnect();
        this.cancelAnimations();
      };
      this.onVisibility = () => { if (document.hidden) this.cancelAnimations(); };
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      if (!Element.prototype.animate || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || this.seen.has(entry.target)) return;
          this.seen.add(entry.target);
          this.observer.unobserve(entry.target);
          if (this.motion.matches || document.hidden) return;
          const heading = entry.target.dataset.actionEntry === 'heading';
          const frames = heading
            ? [{ opacity: .65, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }]
            : [{ opacity: .75 }, { opacity: 1 }];
          try {
            const animation = entry.target.animate(frames, { duration: heading ? 450 : 350, easing: 'cubic-bezier(.22,1,.36,1)' });
            this.active.add(animation);
            animation.onfinish = animation.oncancel = () => this.active.delete(animation);
          } catch (_) {}
        });
      }, { threshold: 0, rootMargin: '0px 0px -16px 0px' });
      if (!this.motion.matches) this.querySelectorAll('[data-action-entry]').forEach(target => this.observer.observe(target));
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.observer?.disconnect();
      this.cancelAnimations();
      this.motion.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-tamping-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-tamping-details')) {
  customElements.define('vabica-tamping-details', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.seen = this.seen || new WeakSet();
      this.active = new Set();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.cancelAnimations = () => {
        this.active.forEach(animation => animation.cancel());
        this.active.clear();
      };
      this.onMotion = () => {
        if (!this.motion.matches) return;
        this.observer?.disconnect();
        this.cancelAnimations();
      };
      this.onVisibility = () => { if (document.hidden) this.cancelAnimations(); };
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      if (!Element.prototype.animate || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || this.seen.has(entry.target)) return;
          this.seen.add(entry.target);
          this.observer.unobserve(entry.target);
          if (this.motion.matches || document.hidden) return;
          const heading = entry.target.dataset.detailsEntry === 'heading';
          const frames = heading
            ? [{ opacity: .65, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }]
            : [{ opacity: .75 }, { opacity: 1 }];
          try {
            const animation = entry.target.animate(frames, { duration: heading ? 450 : 300, easing: 'cubic-bezier(.22,1,.36,1)' });
            this.active.add(animation);
            animation.onfinish = animation.oncancel = () => this.active.delete(animation);
          } catch (_) {}
        });
      }, { threshold: 0, rootMargin: '0px 0px -16px 0px' });
      if (!this.motion.matches) this.querySelectorAll('[data-details-entry]').forEach(target => this.observer.observe(target));
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.observer?.disconnect();
      this.cancelAnimations();
      this.motion.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-tamping-fit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-tamping-fit')) {
  customElements.define('vabica-tamping-fit', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.items = Array.from(this.querySelectorAll('details'));
      this.animations = new Map();
      this.entryAnimations = new Set();
      this.seen = this.seen || new WeakSet();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.nativeNames = new Map(this.items.map(item => [item, item.getAttribute('name')]));
      this.onClick = event => {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        const item = summary.parentElement;
        const opening = item.dataset.opening === undefined ? !item.open : item.dataset.opening !== 'true';
        if (opening) this.items.forEach(other => { if (other !== item && (other.open || other.dataset.opening === 'true')) this.toggleItem(other, false); });
        this.toggleItem(item, opening);
      };
      this.finishAll = () => {
        Array.from(this.animations.entries()).forEach(([item, record]) => this.finishItem(item, record.opening));
        this.entryAnimations.forEach(animation => animation.cancel());
        this.entryAnimations.clear();
      };
      this.onMotion = () => { if (this.motion.matches) { this.observer?.disconnect(); this.finishAll(); } };
      this.onVisibility = () => { if (document.hidden) this.finishAll(); };
      this.onResize = () => this.finishAll();
      this.onBlockSelect = event => {
        const item = event.target.closest('details');
        if (!item || !this.contains(item)) return;
        this.items.forEach(other => { if (other !== item) this.finishItem(other, false); });
        this.finishItem(item, true);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('resize', this.onResize);
      this.items.forEach(item => {
        item.removeAttribute('name');
        item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
      });
      this.main = Array.from(document.querySelectorAll('product-info[id^="MainProduct-"]')).find(main => main.dataset.productId === this.dataset.productId);
      if (this.main && 'MutationObserver' in window) {
        this.purchaseObserver = new MutationObserver(() => this.syncAmazon());
        this.purchaseObserver.observe(this.main, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'target', 'rel'] });
      }
      this.syncAmazon();
      if (!Element.prototype.animate || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || this.seen.has(entry.target)) return;
          this.seen.add(entry.target);
          this.observer.unobserve(entry.target);
          if (this.motion.matches || document.hidden) return;
          try {
            const animation = entry.target.animate([{ opacity: .65, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)' });
            this.entryAnimations.add(animation);
            animation.onfinish = animation.oncancel = () => this.entryAnimations.delete(animation);
          } catch (_) {}
        });
      }, { threshold: 0, rootMargin: '0px 0px -16px 0px' });
      if (!this.motion.matches) this.querySelectorAll('[data-fit-entry]').forEach(target => this.observer.observe(target));
    }
    syncAmazon() {
      const source = this.main?.querySelector('.vabica-product__purchase .vabica-product__amazon');
      const button = this.querySelector('[data-fit-amazon]');
      if (!source || !button) return;
      ['href', 'target', 'rel'].forEach(attribute => {
        const value = source.getAttribute(attribute);
        if (value === null) button.removeAttribute(attribute);
        else button.setAttribute(attribute, value);
      });
      const note = this.querySelector('[data-fit-amazon-note]');
      if (note) note.hidden = source.getAttribute('target') !== '_blank';
    }
    toggleItem(item, opening) {
      const start = item.getBoundingClientRect().height;
      const old = this.animations.get(item);
      if (old) { old.animation.onfinish = null; old.animation.cancel(); this.animations.delete(item); }
      item.dataset.opening = String(opening);
      item.querySelector('summary').setAttribute('aria-expanded', String(opening));
      if (this.motion.matches || !item.animate) { this.finishItem(item, opening); return; }
      item.open = true;
      const summary = item.querySelector('summary');
      const answer = item.querySelector('.vb-tamping-fit__answer');
      const end = summary.getBoundingClientRect().height + (opening ? answer.getBoundingClientRect().height : 0) + 1;
      item.style.overflow = 'hidden';
      try {
        const animation = item.animate([{ height: start + 'px' }, { height: end + 'px' }], { duration: 230, easing: 'ease-in-out' });
        const record = { animation, opening };
        this.animations.set(item, record);
        animation.onfinish = () => { if (this.animations.get(item) === record) this.finishItem(item, opening); };
      } catch (_) { this.finishItem(item, opening); }
    }
    finishItem(item, opening) {
      const record = this.animations.get(item);
      if (record) {
        record.animation.onfinish = null;
        this.animations.delete(item);
        record.animation.cancel();
      }
      item.open = opening;
      item.style.overflow = '';
      delete item.dataset.opening;
      item.querySelector('summary').setAttribute('aria-expanded', String(opening));
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.observer?.disconnect();
      this.purchaseObserver?.disconnect();
      this.finishAll();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.motion.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('resize', this.onResize);
      this.items.forEach(item => {
        const name = this.nativeNames.get(item);
        if (name !== null) item.setAttribute('name', name);
        item.querySelector('summary').removeAttribute('aria-expanded');
      });
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-tamping-layout"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vabica-tamping-layout')) {
  customElements.define('vabica-tamping-layout', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.controls = Array.from(this.querySelectorAll('[data-station-control]'));
      this.panels = Array.from(this.querySelectorAll('[data-station-panel]'));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width:749px)');
      this.animations = new Set();
      this.image = this.querySelector('img');
      this.activeKey = this.panels[0]?.dataset.stationPanel;
      this.cancelAnimations = () => {
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
      };
      this.onClick = event => {
        const control = event.target.closest('[data-station-control]');
        if (!control || !this.contains(control) || !this.hasAttribute('data-enhanced')) return;
        if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.select(control.dataset.stationControl, true);
      };
      this.onKey = event => {
        const control = event.target.closest('[data-station-control]');
        if (!control || !this.contains(control) || !this.hasAttribute('data-enhanced')) return;
        if (event.key === ' ') {
          event.preventDefault();
          this.select(control.dataset.stationControl, true);
        }
      };
      this.onFocus = () => this.cancelAnimations();
      this.onMotion = () => { if (this.motion.matches) this.cancelAnimations(); };
      this.onVisibility = () => { if (document.hidden) this.cancelAnimations(); };
      this.onError = () => this.fallback();
      this.onLoad = () => {
        this.removeAttribute('data-image-failed');
        this.enhance();
      };
      this.onImageAlt = () => {
        if (!this.image) return;
        try {
          const alts = JSON.parse(this.querySelector('[data-station-image-alts]').textContent);
          this.image.alt = this.mobile.matches ? alts.mobile : alts.desktop;
        } catch (_) {}
      };
      this.onBlockSelect = event => {
        const panel = event.target.closest('[data-station-panel]');
        if (panel && this.contains(panel) && this.hasAttribute('data-enhanced')) this.select(panel.dataset.stationPanel, false);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('focusin', this.onFocus);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.motion.addEventListener('change', this.onMotion);
      this.mobile.addEventListener('change', this.onImageAlt);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.image?.addEventListener('error', this.onError);
      this.image?.addEventListener('load', this.onLoad);
      this.onImageAlt();
      if (this.image && this.activeKey) {
        if (this.image.complete && !this.image.naturalWidth) this.fallback();
        else this.enhance();
      }
      if (!this.played && Element.prototype.animate && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.played = true;
          this.observer.disconnect();
          if (this.motion.matches || document.hidden) return;
          const header = this.querySelector('[data-station-entry]');
          if (header && !header.contains(document.activeElement)) this.animateTarget(header, [
            { opacity: .65, transform: 'translateY(12px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], 450);
        }, { threshold: 0, rootMargin: '0px 0px -16px 0px' });
        this.observer.observe(this.querySelector('[data-station-entry]'));
      }
    }
    animateTarget(target, frames, duration) {
      if (!target.animate) return;
      try {
        const animation = target.animate(frames, { duration, easing: 'cubic-bezier(.22,1,.36,1)' });
        this.animations.add(animation);
        animation.onfinish = animation.oncancel = () => this.animations.delete(animation);
      } catch (_) {}
    }
    enhance() {
      if (!this.activeKey || !this.panels.length) return;
      this.controls.forEach(control => control.setAttribute('role', 'button'));
      this.setAttribute('data-enhanced', '');
      this.select(this.activeKey, false);
    }
    select(key, animate) {
      if (!this.panels.some(panel => panel.dataset.stationPanel === key)) return;
      const changed = key !== this.activeKey;
      this.activeKey = key;
      this.cancelAnimations();
      this.controls.forEach(control => control.setAttribute('aria-pressed', String(control.dataset.stationControl === key)));
      this.panels.forEach(panel => {
        const selected = panel.dataset.stationPanel === key;
        panel.toggleAttribute('data-active', selected);
        panel.setAttribute('aria-hidden', String(!selected));
        panel.inert = !selected;
        if (selected && changed && animate && !this.motion.matches && !document.hidden) {
          this.animateTarget(panel, [{ opacity: .4 }, { opacity: 1 }], this.mobile.matches ? 180 : 220);
        }
      });
    }
    fallback() {
      this.cancelAnimations();
      this.removeAttribute('data-enhanced');
      this.setAttribute('data-image-failed', '');
      this.controls.forEach(control => {
        control.removeAttribute('role');
        control.removeAttribute('aria-pressed');
      });
      this.panels.forEach(panel => {
        panel.removeAttribute('aria-hidden');
        panel.removeAttribute('data-active');
        panel.inert = false;
      });
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.observer?.disconnect();
      this.cancelAnimations();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.removeEventListener('focusin', this.onFocus);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.motion.removeEventListener('change', this.onMotion);
      this.mobile.removeEventListener('change', this.onImageAlt);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.image?.removeEventListener('error', this.onError);
      this.image?.removeEventListener('load', this.onLoad);
      this.fallback();
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vabica-walnut-story"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const initialize=(root)=>{
      root.querySelectorAll('[data-vb-walnut-panel]').forEach((panel)=>{
        if(panel.dataset.vbWalnutReady)return;
        panel.dataset.vbWalnutReady='true';
        if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window)||!Element.prototype.animate)return;
        const observer=new IntersectionObserver((entries)=>{
          entries.forEach((entry)=>{
            if(!entry.isIntersecting)return;
            panel.querySelectorAll('.vb-walnut-panel__copy>*').forEach((element,index)=>{
              element.animate([{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,delay:index*80,easing:'cubic-bezier(.2,.65,.3,1)',fill:'backwards'});
            });
            observer.unobserve(panel);
          });
        },{threshold:.15});
        observer.observe(panel);
      });
    };
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initialize(document),{once:true});}else{initialize(document);}
    document.addEventListener('shopify:section:load',(event)=>initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
